var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"affiliated-permission-app"},[_c('span',{staticClass:"section-title"},[_vm._v(" Aplicativo")]),_c('p',{staticClass:"subtitle mt-1"},[_vm._v("Aqui você define o que seu associado pode fazer ou não, em relação ao aplicativo da rede")]),_c('div',{staticClass:"cards"},_vm._l((_vm.permissions),function(permission,index){return _c('permission-card',{key:index,attrs:{"title":permission.title,"subtitle":permission.subtitle,"alertMessage":permission.alert},model:{value:(_vm.localFranchiseePermissions[permission.permission]),callback:function ($$v) {_vm.$set(_vm.localFranchiseePermissions, permission.permission, $$v)},expression:"localFranchiseePermissions[permission.permission]"}})}),1),_c('mf-action-buttons',{staticClass:"mt-4",attrs:{"primary-button":{
      text: 'Salvar alterações',
      action: _vm.save,
      isVisible: true,
      isDisabled: _vm.disableButtons,
      isLoading: _vm.loadingSave,
    },"extra-button":{
      text: 'Descartar alterações',
      action: _vm.cancel,
      isVisible: true,
      isDisabled: _vm.disableButtons,
    }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }